import React from 'react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';
import { DEFAULT_CATEGORY, DEFAULT_STORE } from '../../config';
import GenericProfilePage from '../../pages/customerPages/GenericProfilePage/GenericProfilePage';
import ProviderProfilePage from '../../pages/customerPages/ProviderProfilePage/ProviderProfilePage';
import ReviewFromPastCustomerPage from '../../pages/ReviewFromPastCustomerPage/ReviewFromPastCustomerPage';

interface IProviderProfileRoutesProps {}

const ProviderProfileRoutes: React.FC<React.PropsWithChildren<IProviderProfileRoutesProps>> = ({}) => {
  // NOTE: this route can be either /@/.. or /profile/..
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Redirect
        exact
        path={`${path}/:profileId`}
        to={`${path}/:profileId/${DEFAULT_STORE}/${DEFAULT_CATEGORY}`}
      />

      <Redirect
        exact
        path={`${path}/:profileId/makeup-and-hair`}
        to={`${path}/:profileId/${DEFAULT_STORE}/${DEFAULT_CATEGORY}`}
      />

      <Route
        exact
        path={[
          `${path}/:profileId/:storeSlug/:categorySlug`,
          `${path}/:profileId/appointments/:appointmentId`,
          `${path}/:profileId/appointments/:appointmentId/:offerKey`,
        ]}
        component={GenericProfilePage}
      />

      <Route
        exact
        path={`${path}/:profileId/:categorySlug/reviews/new`}
        component={ReviewFromPastCustomerPage}
      />

      <Route
        exact
        path={`${path}/:profileId/:categorySlug/reviews/:reviewId/:key`}
        component={ReviewFromPastCustomerPage}
      />
    </Switch>
  );
};
export default ProviderProfileRoutes;
